import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { Table, TableRow, TableBody, TableCell, TableContainer, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MyPagination from "./MyPagination";
import { createRoot } from "react-dom/client";
import { asyncRequest } from "src/services/network";
import ListHead from "./ListHead";
import UserInfo from "./UserInfo";
import { OutlinedInput } from "@mui/material";
import { InputAdornment } from "@mui/material";
import { Icon } from "@iconify/react";
import searchFill from "@iconify/icons-eva/search-fill";

const modalRoot = document.querySelector("#image-picker");

const TABLE_HEAD = [
  { id: "user", label: "用户", alignRight: false },
  { id: "mobile", label: "手机号", alignRight: false },
];

export const TiejunPickerDialog = ({ title, condition = {}, multiple, visible, onClose, onSelect }) => {
  const ref = useRef();
  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(visible);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 15,
    search: "",
    ...condition,
  });

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/user/tiejun/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handleConfirmSelection = (row) => {
    onSelect(multiple ? [row] : row);
    handleClose();
  };

  function handlePageChange(event, value) {
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="unset">
      <DialogTitle>
        {title}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent sx={{ minHeight: 530, minWidth: 600, display: 'flex', flexDirection: 'column' }}>
        <OutlinedInput
          // label="UID"
          size="small"
          value={filter.search}
          onChange={(event) => {
            setFilter({
              ...filter,
              page: 0,
              search: event.target.value,
            });
          }}
          placeholder="搜索..."
          startAdornment={
            <InputAdornment position="start">
              <Box component={Icon} icon={searchFill} sx={{ color: "text.disabled" }} />
            </InputAdornment>
          }
        />
        <TableContainer>
          <Table>
            <ListHead headLabel={TABLE_HEAD} />
            <TableBody>
              {items.map((row) => {
                const { uid, nickname, avatar, user, mobile, createdAt } = row;
                const isItemSelected = selected.indexOf(uid) !== -1;

                return (
                  <TableRow hover key={uid} role="checkbox" selected={isItemSelected} onClick={() => handleConfirmSelection(row)}>
                    <TableCell align="left">
                      <UserInfo {...user} />
                    </TableCell>
                    <TableCell align="left">{user.mobile}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
      </DialogContent>
    </Dialog>
  );
};

let root = null;

const TiejunPicker = ({ title = "请选择铁军", condition = {}, multiple = false, onSelect = () => {}, onClose = () => {} }) => {
  if (!root) {
    root = createRoot(modalRoot);
  }
  root.render(
    <TiejunPickerDialog
      visible={true}
      condition={condition}
      onClose={() => {
        root.unmount();
        root = null;
        onClose();
      }}
      onSelect={onSelect}
      title={title}
      multiple={multiple}
    />
  );
};

export default TiejunPicker;
